import classnames from 'classnames'
import Group from 'entities/group'
import PropTypes from 'prop-types'
import React from 'react'
import { propTypeInstantiableTo } from 'supports/custom_prop_types'
import styles from './switchable_groups.module.scss'

const SwitchableGroups = ({ groups, selected, onMouseEnter }) =>
  groups.map((group, index) => {
    const isActive = selected.id === group.id
    const className = classnames(styles.groupItem, 'has-state', {
      [styles.isActive]: isActive
    })
    const iconClassName = classnames('ic-check', styles.icon, {
      [styles.isIconActive]: isActive
    })

    return (
      <a
        key={group.id}
        href={Routes.managersSessionsGroupPath({ id: group.id })}
        data-method="patch"
        data-index={index}
        className={className}
        role="menuitem"
        tabIndex="-1"
        onMouseEnter={onMouseEnter}
      >
        {isActive ? <i className={iconClassName} /> : null}
        {group.name}
      </a>
    )
  })

SwitchableGroups.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.instanceOf(Group)).isRequired,
  selected: propTypeInstantiableTo(Group).isRequired,
  onMouseEnter: PropTypes.func.isRequired
}

export default SwitchableGroups
